import { type SVGProps } from 'react';

export const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhatsAppIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.472 14.382C17.113 14.199 15.365 13.339 15.055 13.226C14.745 13.114 14.522 13.058 14.299 13.417C14.076 13.775 13.434 14.565 13.239 14.788C13.044 15.01 12.849 15.038 12.491 14.854C12.132 14.671 10.996 14.309 9.656 13.127C8.602 12.199 7.903 11.059 7.708 10.7C7.513 10.341 7.688 10.144 7.867 9.966C8.026 9.806 8.225 9.549 8.404 9.354C8.584 9.159 8.639 9.019 8.751 8.796C8.863 8.573 8.807 8.378 8.723 8.199C8.639 8.02 7.911 6.277 7.636 5.601C7.368 4.941 7.096 5.029 6.893 5.019L6.237 5.009C6.014 5.009 5.652 5.093 5.342 5.452C5.032 5.811 4.116 6.671 4.116 8.414C4.116 10.157 5.37 11.844 5.549 12.067C5.729 12.289 7.901 15.69 11.077 17.153C11.873 17.504 12.495 17.713 12.977 17.869C13.776 18.126 14.506 18.089 15.082 18.003C15.724 17.907 17.011 17.181 17.293 16.387C17.575 15.593 17.575 14.913 17.491 14.774C17.407 14.635 17.184 14.564 17.472 14.382ZM10.854 21.746H10.849C9.233 21.7461 7.64863 21.2871 6.273 20.417L5.859 20.17L2.535 21.025L3.406 17.784L3.132 17.354C2.16207 15.9245 1.64186 14.248 1.643 12.534C1.645 6.997 6.086 2.559 11.627 2.559C14.316 2.559 16.848 3.466 18.857 5.121C20.866 6.776 21.945 9.093 21.944 11.787C21.942 17.324 17.501 21.761 11.961 21.761L10.854 21.746ZM20.272 3.706C18.1086 1.65071 15.2339 0.485564 12.218 0.5C5.542 0.5 0.118 5.92 0.115 12.595C0.114 14.445 0.588 16.252 1.49 17.859L0 24L6.304 22.541C7.852 23.364 9.58199 23.7963 11.34 23.798H11.346C18.021 23.798 23.445 18.374 23.448 11.699C23.4491 8.86812 22.4354 6.1278 20.596 3.975L20.272 3.706Z"
      fill="currentColor"
    />
  </svg>
);

export const AuthenticatorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V12M12 16H12.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="12"
      r="3"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const DeviceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 1C8.13401 1 5 4.13401 5 8C5 9.17 5.27 10.27 5.75 11.26C5.75 11.26 5.86 11.45 5.89 11.49L12 22L18.13 11.47C18.15 11.44 18.25 11.26 18.25 11.26C18.73 10.27 19 9.17 19 8C19 4.13401 15.866 1 12 1Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 15.5L12 19L15.5 15.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Check mark icon for completed steps
export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 6L9 17L4 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);